import type { Attendee, AudioTile, AVTile } from '@/composables/useAudioVideo/types'

export module TileUtils {
  export function isLocal(tile: Omit<AVTile, 'id'>): boolean {
    return tile.isLocal ?? false
  }

  export function isContent(tile: { chimeId?: string | null }): boolean {
    return tile.chimeId?.includes('#content') ?? false
  }

  export function tileUserId(tile: Omit<AVTile, 'id'>): number {
    return Number(tile.userId)
  }

  export function isLimited(attendee: AudioTile): boolean {
    return attendee.limited
  }

  export function getInitials(attendee: Attendee): string {
    return attendee.initials ?? 'VMU' // VRIFY Meetings User
  }

  export function isHost(attendee: Attendee): boolean {
    return attendee.deckUserType === 'host'
  }

  export function tileId(tile: Omit<AVTile, 'id'>): number | undefined {
    return tile.tileId
  }
}
